export const STATIC_ENDPOINTS = {
  NEWSLETTER_SUBSCRIBE: '/contact/newsletter/',
  CONTACT_US: '/contact/',
} as const
